"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var react_i18next_1 = require("react-i18next");
var ConfirmModal_1 = __importDefault(require("../ConfirmModal"));
var useUnload_1 = __importDefault(require("../../../hooks/useUnload"));
var lodash_1 = __importDefault(require("lodash"));
var RouterPrompt = function (_a) {
    var _b = _a.cancelButtonTitle, cancelButtonTitle = _b === void 0 ? 'Account.Settings.PROMPT_MODAL.CLOSE' : _b, _c = _a.confirmButtonTitle, confirmButtonTitle = _c === void 0 ? 'Account.Settings.PROMPT_MODAL.CONFIRM' : _c, _d = _a.headerTitle, headerTitle = _d === void 0 ? 'Account.Settings.PROMPT_MODAL.TITLE' : _d, _e = _a.content, content = _e === void 0 ? '' : _e, handleCancel = _a.handleCancel;
    var t = react_i18next_1.useTranslation('common').t;
    var history = react_router_dom_1.useHistory();
    var _f = react_1.useState(false), showPrompt = _f[0], setShowPrompt = _f[1];
    var _g = react_1.useState(''), currentPath = _g[0], setCurrentPath = _g[1];
    useUnload_1.default(function (e) {
        e.preventDefault();
        e.returnValue = '';
    });
    react_1.useEffect(function () {
        history.block(function (prompt) {
            setShowPrompt(true);
            setCurrentPath(prompt.pathname);
            return 'true';
        });
        return function () {
            history.block(function () { });
        };
    }, [history]);
    var onConfirm = function () {
        setShowPrompt(false);
    };
    var onCancel = function () {
        history.block(function () { });
        setShowPrompt(false);
        history.push(currentPath);
        lodash_1.default.isFunction(handleCancel) && handleCancel();
    };
    return (react_1.default.createElement(ConfirmModal_1.default, { open: showPrompt, headerTitle: t(headerTitle), cancelButtonTitle: t(cancelButtonTitle), confirmButtonTitle: t(confirmButtonTitle), content: content, size: "small", onCancel: onCancel, onConfirm: onConfirm }));
};
exports.default = react_1.memo(RouterPrompt);
